// import React, { useState } from 'react';
// import './About.css';

// const About = () => {
//   const [section, setSection] = useState(null);

//   const handleClick = (selected) => {
//     setSection(selected);
//   };

//   const renderContent = () => {
//     switch (section) {
//       case 'about':
//         return (
//           <>
//             <button className="back-btn" onClick={() => setSection(null)}>←</button>
//             <p>
//               I'm Aryan Thakur, a final-year CS student who enjoys solving problems a bit too much.
//               Give me a tricky algorithm and I’ll gladly lose sleep over it—just for that sweet, satisfying AC.
//               <br /><br />
//               I like building tools that actually do something useful (AI-powered stuff, dev utilities,
//               Q&A platforms—those kinds of things). I'm pretty hands-on with React, TypeScript, and
//               whatever helps get the job done.
//               <br /><br />
//               Honestly, I’m only building this portfolio because everyone says you *need* one.
//               Would rather be fixing a bug or grinding on Codeforces, but here we are—trying to make this page look cool too.
//               <br /><br />
//               Outside code, I’m probably sketching dumb UI ideas, experimenting with setups I’ll never use,
//               or doing cardio just to survive leg day.
//             </p>
//           </>
//         );
//       case 'skills':
//         return (
//           <>
//             <button className="back-btn" onClick={() => setSection(null)}>←</button>
//             <p>
//               Languages: C++, JavaScript, TypeScript, Python<br />
//               Frontend: React, Next.js<br />
//               Backend: Node.js, Express, FastAPI<br />
//               Databases: PostgreSQL, MongoDB<br />
//               Tools: Git, Docker, Linux, VSCode<br />
//               Focused on building clean UIs and real-world utility tools.
//             </p>
//           </>
//         );
//       case 'education':
//         return (
//           <>
//             <button className="back-btn" onClick={() => setSection(null)}>←</button>
//             <p>
//               Final Year B.Tech – Computer Science<br />
//               University of Petroleum & Energy Studies (2022 – 2026)<br />
//               Core Areas: DSA, DBMS, Operating Systems, Web Development.
//             </p>
//             <br></br>
//             <p>
//               Intermediate – CBSE<br />
//               St. Froebel Senior Secondary School (2021 – 2022)<br />
//               Core Areas: Physics, Chemistry, Maths.
//             </p>
//             <br></br>
//             <p>
//               Matriculation – CBSE<br />
//               St. Froebel Senior Secondary School (2019 – 2020)<br />
//               Core Areas: Science, Maths, Social Studies.
//             </p>
//           </>
//         );
//       default:
//         return null;
//     }
//   };

//   return (
//     <section id="about">
//       {!section && (
//         <>
//           <h1 className="about-heading-huge" onClick={() => handleClick('about')}>
//             ABOUT ME.
//           </h1>
//           <div className="bottom-left-label" onClick={() => handleClick('skills')}>SKILLS</div>
//           <div className="bottom-right-label" onClick={() => handleClick('education')}>EDUCATION</div>
//         </>
//       )}
//       {section && <div className="about-content reveal">{renderContent()}</div>}
//     </section>
//   );
// };

// export default About;
import React, { useState } from 'react';
import './About.css';
import upeslogo from "../../assets/upes-logo.jpg";
import froebelogo from "../../assets/sfs-logo.png";


const About = () => {
  const [section, setSection] = useState(null);

  const handleClick = (selected) => {
    setSection(selected);
  };

  const renderContent = () => {
    switch (section) {
      case 'about':
        return (
          <>
            <button className="back-btn" onClick={() => setSection(null)}>←</button>
            <p>
              I'm Aryan Thakur, a final-year CS student who enjoys solving problems a bit too much.
              Give me a tricky algorithm and I’ll gladly lose sleep over it—just for that sweet, satisfying AC.
              <br /><br />
              I like building tools that actually do something useful (AI-powered stuff, dev utilities,
              Q&A platforms—those kinds of things). I'm pretty hands-on with React, TypeScript, and
              whatever helps get the job done.
              <br /><br />
              Honestly, I’m only building this portfolio because everyone says you *need* one.
              Would rather be fixing a bug or grinding on Codeforces, but here we are—trying to make this page look cool too.
              <br /><br />
              Outside code, I’m probably sketching dumb UI ideas, experimenting with setups I’ll never use,
              or doing cardio just to survive leg day.
            </p>
          </>
        );

      case 'skills':
        const skillSet = [
          { name: 'C++', level: 90 },
          { name: 'JavaScript', level: 85 },
          { name: 'TypeScript', level: 80 },
          { name: 'Python', level: 75 },
          { name: 'React', level: 90 },
          { name: 'Next.js', level: 70 },
          { name: 'Node.js', level: 80 },
          { name: 'Express', level: 75 },
          { name: 'FastAPI', level: 70 },
          { name: 'PostgreSQL', level: 80 },
          { name: 'MongoDB', level: 75 },
          { name: 'Git', level: 90 },
          { name: 'Docker', level: 70 },
          { name: 'Linux', level: 85 },
          { name: 'VSCode', level: 95 }
        ];

        return (
          <>
            <button className="back-btn" onClick={() => setSection(null)}>←</button>
            <div className="skills-grid">
              {skillSet.map((skill, index) => (
                <div className="skill-tile" key={index}>
                  <span className="skill-name">{skill.name}</span>
                  <div className="skill-meter">
                    <div className="skill-fill" style={{ width: `${skill.level}%` }}></div>
                  </div>
                  <span className="skill-percent">{skill.level}%</span>
                </div>
              ))}
            </div>
          </>
        );

      case 'education':
  return (
    <>
      <button className="back-btn" onClick={() => setSection(null)}>←</button>
      <div className="education-container">
        <div className="edu-block">
          <img src={upeslogo} alt="UPES" className="edu-logo" />
          <div className="edu-details">
            <h3>B.Tech – Computer Science</h3>
            <p className="edu-duration">2022 – 2026</p>
            <p className="edu-desc">
              University of Petroleum & Energy Studies<br />
              Core Areas: DSA, DBMS, OS, Web Development
            </p>
          </div>
        </div>

        <div className="edu-block">
          <img src={froebelogo} alt="St. Froebel School" className="edu-logo" />
          <div className="edu-details">
            <h3>Intermediate</h3>
            <p className="edu-duration">2021 – 2022</p>
            <p className="edu-desc">
              St. Froebel Sr Sec School – CBSE<br />
              Core Areas: Physics, Chemistry, Maths
            </p>
          </div>
        </div>

        <div className="edu-block">
          <img src={froebelogo} alt="St. Froebel School" className="edu-logo" />
          <div className="edu-details">
            <h3>Matriculation</h3>
            <p className="edu-duration">2019 – 2020</p>
            <p className="edu-desc">
              St. Froebel Sr Sec School – CBSE<br />
              Core Areas: Science, Maths, Social Studies
            </p>
          </div>
        </div>
      </div>
    </>
  );


      default:
        return null;
    }
  };

  return (
    <section id="about">
      {!section && (
        <>
          <h1 className="about-heading-huge" onClick={() => handleClick('about')}>
            ABOUT ME.
          </h1>
          <div className="bottom-left-label" onClick={() => handleClick('skills')}>SKILLS</div>
          <div className="bottom-right-label" onClick={() => handleClick('education')}>EDUCATION</div>
        </>
      )}
      {section && <div className="about-content reveal">{renderContent()}</div>}
    </section>
  );
};

export default About;
